export default __webpack_public_path__ + "static/media/grupo-familiar.04cfa7a2.svg";